/**
 * Mapa route name → IDs de demos (demosData.js).
 * Editar aquí cuando se agreguen tutoriales contextuales a nuevas vistas.
 */
export const tutorialByRoute = {
    "registrar-abono-centro-costo": ["miembros-registrar-pago"],
    "abonar-cobros-cuotas": ["miembros-registrar-pago"],
    "mis-pagos": ["miembros-ver-pagos-gastos-ingresos"],
    "ver-gastos": ["miembros-ver-pagos-gastos-ingresos"],
    "ver-ingresos": ["miembros-ver-pagos-gastos-ingresos"],
    "gestion-centro-costos": [
        "directivos-gestionar-fondos-recaudacion",
        "directivos-crear-fondo-colecta",
        "directivos-crear-fondo-montos-iguales",
        "directivos-crear-fondo-montos-distintos",
    ],
    "validar-pagos": ["directivos-validar-pago", "directivos-validar-pagos-fondo"],
    "crear-link-asociacion-curso": ["directivos-link-invitacion"],
    "registrar-gasto": ["directivos-registrar-gasto"],
    "registrar-ingreso": ["directivos-registrar-ingreso-extra"],
    "ventas-list": ["miembros-ventas"],
    "donaciones-list": ["miembros-donaciones"],
    "gestion-ventas": ["directivos-gestionar-ventas"],
    "gestion-donaciones": ["directivos-gestionar-donaciones"],
};
